
    import '/opt/buildhome/repo/packages/x/docs/react/compatible-style.en-US.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/compatible-style.en-US.md?type=demo')
};